<template>
    <ion-item>
        <ion-label style="opacity: 1;">
            <ion-item lines="none" class="ion-no-padding ion-nowrap">
                <ion-label>{{ setting.label }}</ion-label>
                <ion-select v-model="setting.value"
                            :name="label"
                            :value="setting.value !== null ? setting.value.toString(): 'null'"
                            :placeholder="$t('ncrypt.make_a_choice')"
                            :ok-text="$t('ncrypt.select')" :cancel-text="$t('cancel')"
                            @ionChange="setting.value = $event.detail.value"
                            autocomplete="off"
                            :disabled="setting.inherited"
                            interface="popover"
                >
                    <ion-select-option
                            v-for="(option, i) in setting.allowed"
                            v-bind:key="`${label}-${i}`"
                            :value="option !== null ? option.toString() : 'null'"
                            v-text="humanReadableOption(option)"
                    ></ion-select-option>
                </ion-select>
            </ion-item>
            <ion-text color="dark">
                <p style="opacity: 1; text-align: right; position: relative; top: -8px;" v-if="setting.inherited">
                    <ion-icon ios='alert-circle' md="alert-circle" slot="start" color="primary"/>

                    {{ $t('ncrypt.setting_is_inherited_from_company') }}
                </p>
                <p style="opacity: 1;">{{ setting.description }}</p>
            </ion-text>
        </ion-label>
    </ion-item>
</template>

<script>
    export default {
        name: "SettingsListItem",
        props: {
            setting: {type: Object},
            label: {type: String},
        },
        methods: {
            humanReadableOption(option) {
                if (option === true) {
                    return this.$t('ncrypt.yes');
                }
                if (option === false) {
                    return this.$t('ncrypt.no');
                }
                if (option === null) {
                    return this.$t('ncrypt.default_or_own_choice');
                }
                return option;
            },
        },
    }
</script>
